module.exports = __webpack_public_path__ + "img/pic_s6_lite.b81d71f5.png";